(() => {
  const init = (section) => {
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const plans = Array.from(
      section.querySelectorAll('[data-bendu-plan]')
    );

    const categories = Array.from(
      section.querySelectorAll('[data-bendu-category]')
    );

    const summaryKit = section.querySelector(
      '[data-bendu-summary-kit]'
    );

    const summaryTotal = section.querySelector(
      '[data-bendu-summary-total]'
    );

    const summaryCashback = section.querySelector(
      '[data-bendu-summary-cashback]'
    );

    const summaryCashbackRate = section.querySelector(
      '[data-bendu-summary-cashback-rate]'
    );

    const summaryFreeShipping = section.querySelector(
      '[data-bendu-summary-free-shipping]'
    );

    const slots = section.querySelector(
      '[data-bendu-slots]'
    );

    const cta = section.querySelector(
      '[data-bendu-cta]'
    );

    const ctaText = section.querySelector(
      '[data-bendu-cta-text]'
    );

    const missing = section.querySelector(
      '[data-bendu-missing]'
    );

    const summary = section.querySelector(
      '[data-bendu-summary]'
    );

    const mobileBar = section.querySelector(
      '[data-bendu-mobile-bar]'
    );

    const mobileBarTrigger = section.querySelector(
      '[data-bendu-mobile-bar-trigger]'
    );

    const mobileStatus = section.querySelector(
      '[data-bendu-mobile-status]'
    );

    const mobileKit = section.querySelector(
      '[data-bendu-mobile-kit]'
    );

    const mobileTotal = section.querySelector(
      '[data-bendu-mobile-total]'
    );

    const mobileUnits = section.querySelector(
      '[data-bendu-mobile-units]'
    );

    const mobileCashback = section.querySelector(
      '[data-bendu-mobile-cashback]'
    );

    const mobileCashbackRate = section.querySelector(
      '[data-bendu-mobile-cashback-rate]'
    );

    const mobileFreeShipping = section.querySelector(
      '[data-bendu-mobile-free-shipping]'
    );

    const mobileCta = section.querySelector(
      '[data-bendu-mobile-cta]'
    );

    const mobileCtaText = section.querySelector(
      '[data-bendu-mobile-cta-text]'
    );

    if (!plans.length || !cta) return;

    const state = {
      kit: String(
        section.dataset.defaultKit || '1'
      ),

      selections: {},

      openCategoryId: null
    };

    categories.forEach((category) => {
      const categoryId =
        category.dataset.categoryId;

      state.selections[categoryId] = {};

      category
        .querySelectorAll('[data-bendu-product]')
        .forEach((card) => {
          const variantId =
            String(card.dataset.variantId || '');

          const image =
            card.querySelector('img')?.currentSrc ||
            card.querySelector('img')?.src ||
            '';

          state.selections[categoryId][variantId] = {
            qty: 0,
            title:
              card.dataset.productTitle || '',
            price: Number(
              card.dataset.productPrice || 0
            ),
            variantId,
            image
          };
        });
    });

    const normalizeText = (value = '') => {
      return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    };

    const getCategoryType = (category) => {
      const configuredType = (
        category.dataset.categoryType || ''
      ).trim();

      if (
        configuredType &&
        configuredType !== 'custom'
      ) {
        return configuredType;
      }

      const title = normalizeText(
        category.dataset.categoryTitle || ''
      );

      if (
        title.includes('soft bar')
      ) {
        return 'soft';
      }

      if (
        title.includes('sublime')
      ) {
        return 'sublime';
      }

      if (
        title.includes('crispy wafer') ||
        title.includes('crispy')
      ) {
        return 'crispy';
      }

      if (
        title.includes('salty chips') ||
        title.includes('salty')
      ) {
        return 'salty';
      }

      if (
        title.includes('pack pacoca') ||
        title.includes('pacoca')
      ) {
        return 'pacoca';
      }

      if (
        title.includes('creme 150g') ||
        title.includes('creme 150') ||
        title.includes('creme150')
      ) {
        return 'creme150';
      }

      return 'custom';
    };

    const KIT_RULES = {
      '1': {
        soft: 2,
        sublime: 2,
        crispy: 2,
        salty: 2,
        pacoca: 0,
        creme150: 0
      },

      '2': {
        soft: 3,
        sublime: 4,
        crispy: 3,
        salty: 4,
        pacoca: 2,
        creme150: 0
      },

      '3': {
        soft: 4,
        sublime: 4,
        crispy: 4,
        salty: 4,
        pacoca: 4,
        creme150: 1
      },

      '4': {
        soft: 8,
        sublime: 5,
        crispy: 8,
        salty: 6,
        pacoca: 5,
        creme150: 2
      }
    };

    const activePlan = () => {
      return (
        plans.find(
          (plan) =>
            String(plan.dataset.benduPlan) ===
            String(state.kit)
        ) || plans[0]
      );
    };

    const getLimit = (category) => {
      const type = getCategoryType(category);

      const configuredLimit = category.getAttribute(
        `data-limit-kit-${state.kit}`
      );

      if (
        configuredLimit !== null &&
        configuredLimit !== ''
      ) {
        return Number(configuredLimit) || 0;
      }

      const rule = KIT_RULES[state.kit] || {};

      if (
        Object.prototype.hasOwnProperty.call(
          rule,
          type
        )
      ) {
        return Number(rule[type] || 0);
      }

      return 0;
    };

    const isCategoryEnabled = (
      category
    ) => {
      return getLimit(category) > 0;
    };

    const categoryTotal = (
      categoryId
    ) => {
      return Object.values(
        state.selections[
          categoryId
        ] || {}
      ).reduce(
        (total, item) =>
          total +
          Number(item.qty || 0),
        0
      );
    };

    const isCategoryComplete = (
      category
    ) => {
      if (
        !isCategoryEnabled(category)
      ) {
        return true;
      }

      const categoryId =
        category.dataset.categoryId;

      return (
        categoryTotal(categoryId) >=
        getLimit(category)
      );
    };

    const resetSelections = () => {
      Object.values(
        state.selections
      ).forEach((categoryItems) => {
        Object.values(
          categoryItems
        ).forEach((item) => {
          item.qty = 0;
        });
      });
    };

    const firstIncompleteCategory =
      () => {
        return categories.find(
          (category) =>
            isCategoryEnabled(
              category
            ) &&
            !isCategoryComplete(
              category
            )
        );
      };

    const closeAllCategories = () => {
      state.openCategoryId =
        null;

      categories.forEach(
        (category) => {
          category.classList.remove(
            'is-open'
          );

          if (
            isCategoryEnabled(
              category
            )
          ) {
            category.classList.add(
              'is-collapsed'
            );
          }
        }
      );
    };

    const openCategory = (
      category,
      options = {}
    ) => {
      if (
        !category ||
        !isCategoryEnabled(category)
      ) {
        return;
      }

      const {
        scroll = false
      } = options;

      state.openCategoryId =
        category.dataset.categoryId;

      categories.forEach(
        (item) => {
          const active =
            item === category &&
            isCategoryEnabled(item);

          item.classList.toggle(
            'is-open',
            active
          );

          if (
            isCategoryEnabled(item)
          ) {
            item.classList.toggle(
              'is-collapsed',
              !active
            );
          }
        }
      );

      if (scroll) {
        window.setTimeout(() => {
          const rect =
            category.getBoundingClientRect();

          if (
            rect.bottom >
              window.innerHeight - 50 ||
            rect.top < 80
          ) {
            category.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }, 120);
      }
    };

    const openNextIncomplete = (
      currentCategory
    ) => {
      const enabledCategories =
        categories.filter(
          isCategoryEnabled
        );

      const currentIndex =
        enabledCategories.indexOf(
          currentCategory
        );

      let nextCategory =
        null;

      for (
        let i =
          currentIndex + 1;

        i <
        enabledCategories.length;

        i += 1
      ) {
        if (
          !isCategoryComplete(
            enabledCategories[i]
          )
        ) {
          nextCategory =
            enabledCategories[i];

          break;
        }
      }

      if (!nextCategory) {
        nextCategory =
          firstIncompleteCategory();
      }

      if (nextCategory) {
        openCategory(
          nextCategory,
          {
            scroll: true
          }
        );
      } else {
        closeAllCategories();

        if (summary) {
          summary.classList.add(
            'is-ready'
          );
        }
      }
    };

    const updateCategoryVisibility =
      () => {
        categories.forEach(
          (category) => {
            const enabled =
              isCategoryEnabled(
                category
              );

            const categoryId =
              category.dataset.categoryId;

            category.hidden =
              !enabled;

            category.style.display =
              enabled
                ? ''
                : 'none';

            const summaryRow =
              section.querySelector(
                `[data-summary-category="${categoryId}"]`
              );

            if (summaryRow) {
              summaryRow.hidden =
                !enabled;

              summaryRow.style.display =
                enabled
                  ? ''
                  : 'none';
            }

            const mobileCategoryChip =
              section.querySelector(
                `[data-bendu-mobile-category="${categoryId}"]`
              );

            if (mobileCategoryChip) {
              mobileCategoryChip.hidden =
                !enabled;

              mobileCategoryChip.style.display =
                enabled
                  ? ''
                  : 'none';
            }

            if (!enabled) {
              Object.values(
                state.selections[
                  categoryId
                ] || {}
              ).forEach((item) => {
                item.qty = 0;
              });

              category.classList.remove(
                'is-open',
                'is-complete'
              );

              category.classList.add(
                'is-collapsed'
              );
            }
          }
        );

        let stepNumber = 1;

        categories.forEach((category) => {
          if (category.hidden) return;

          stepNumber += 1;

          const stepNum =
            category.querySelector(
              '.bendu-kit-builder__step-num'
            );

          if (stepNum) {
            stepNum.textContent = stepNumber;
          }
        });
      };

    const updateProductCards = (
      category
    ) => {
      const categoryId =
        category.dataset.categoryId;

      const limit =
        getLimit(category);

      const total =
        categoryTotal(
          categoryId
        );

      category
        .querySelectorAll(
          '[data-bendu-product]'
        )
        .forEach((card) => {
          const variantId =
            String(
              card.dataset
                .variantId || ''
            );

          const item =
            state.selections[
              categoryId
            ][variantId];

          const qty =
            item?.qty || 0;

          const qtyWrap =
            card.querySelector(
              '[data-bendu-qty]'
            );

          const qtyValue =
            card.querySelector(
              '[data-bendu-qty-value]'
            );

          const plus =
            card.querySelector(
              '[data-bendu-plus]'
            );

          const minus =
            card.querySelector(
              '[data-bendu-minus]'
            );

          card.classList.toggle(
            'is-selected',
            qty > 0
          );

          if (qtyWrap) {
            qtyWrap.hidden =
              false;
          }

          if (qtyValue) {
            qtyValue.textContent =
              qty;
          }

          if (minus) {
            minus.disabled =
              qty <= 0;
          }

          if (plus) {
            plus.disabled =
              total >= limit;
          }
        });
    };

    const buildCategorySummary = (
      category
    ) => {
      const categoryId =
        category.dataset.categoryId;

      const selected = [];

      Object.values(
        state.selections[
          categoryId
        ] || {}
      ).forEach((item) => {
        if (item.qty > 0) {
          selected.push(
            `${item.qty}× ${item.title}`
          );
        }
      });

      return selected.join(', ');
    };

    const buildSlots = () => {
      if (!slots) return;

      const plan =
        activePlan();

      const units =
        Number(
          plan?.dataset.units || 0
        );

      const selected = [];

      categories.forEach(
        (category) => {
          if (
            !isCategoryEnabled(
              category
            )
          ) {
            return;
          }

          const categoryId =
            category.dataset.categoryId;

          Object.values(
            state.selections[
              categoryId
            ] || {}
          ).forEach((item) => {
            for (
              let i = 0;
              i < item.qty;
              i += 1
            ) {
              selected.push(item);
            }
          });
        }
      );

      slots.innerHTML = '';

      for (
        let i = 0;
        i < units;
        i += 1
      ) {
        const slot =
          document.createElement(
            'span'
          );

        slot.className =
          'bendu-kit-builder__slot';

        const item =
          selected[i];

        if (item) {
          slot.classList.add(
            'is-filled'
          );

          slot.title =
            item.title;

          if (item.image) {
            const img =
              document.createElement(
                'img'
              );

            img.src =
              item.image;

            img.alt =
              item.title;

            img.loading =
              'lazy';

            slot.appendChild(img);
          }
        }

        slots.appendChild(slot);
      }
    };

    const getSelectedTotal = () => {
      let total = 0;

      categories.forEach((category) => {
        if (
          !isCategoryEnabled(
            category
          )
        ) {
          return;
        }

        const categoryId =
          category.dataset.categoryId;

        Object.values(
          state.selections[
            categoryId
          ] || {}
        ).forEach((item) => {
          total +=
            Number(item.price || 0) *
            Number(item.qty || 0);
        });
      });

      return total;
    };

    const formatMoney = (
      cents
    ) => {
      const currency =
        section.dataset.moneyCode ||
        'BRL';

      try {
        return new Intl.NumberFormat(
          'pt-BR',
          {
            style: 'currency',
            currency
          }
        ).format(
          (Number(cents) || 0) /
            100
        );
      } catch (error) {
        return `R$ ${(
          (Number(cents) || 0) /
          100
        )
          .toFixed(2)
          .replace('.', ',')}`;
      }
    };

    const getSelectedUnits = () => {
      return categories.reduce(
        (sum, category) => {
          if (!isCategoryEnabled(category)) {
            return sum;
          }

          return (
            sum +
            categoryTotal(
              category.dataset.categoryId
            )
          );
        },
        0
      );
    };

    let selectedKitId = null;
    let editingDraft = null;
    let editingStorageKey = null;
    let editingFocusCategory = null;
    const saveEditingSelection = () => {
      if (!editingDraft) return;
      editingDraft.kit = String(state.kit);
      editingDraft.selections = Object.entries(state.selections).flatMap(([categoryId, products]) =>
        Object.values(products).filter((item) => item.qty > 0).map((item) => ({ categoryId, variantId: item.variantId, qty: item.qty }))
      );
      try { sessionStorage.setItem(editingStorageKey, JSON.stringify(editingDraft)); } catch (_) {}
    };

    const restoreEditingSelection = () => {
      const kitId = new URL(window.location.href).searchParams.get('bendu_edit');
      if (!kitId) return;
      editingStorageKey = 'bendu-kit-edit:' + kitId;
      try {
        if (sessionStorage.getItem('bendu-kit-removed:' + kitId) === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.delete('bendu_edit');
          window.history.replaceState({}, '', url);
          return;
        }
        const draft = JSON.parse(sessionStorage.getItem(editingStorageKey));
        if (!draft || draft.kitId !== kitId || !plans.some((plan) => String(plan.dataset.benduPlan) === draft.kit)) {
          throw new Error('N\u00e3o foi poss\u00edvel recuperar a sele\u00e7\u00e3o deste kit.');
        }
        state.kit = draft.kit;
        let skipped = false;
        const restore = (category, variantId, qty) => {
          const item = category && state.selections[category.dataset.categoryId]?.[variantId];
          if (!item || !Number.isInteger(qty) || qty < 1 || !isCategoryEnabled(category)) { skipped = true; return; }
          const allowed = Math.min(qty, Math.max(0, getLimit(category) - categoryTotal(category.dataset.categoryId)));
          item.qty += allowed;
          if (allowed !== qty) skipped = true;
          if (variantId === draft.focusVariant) editingFocusCategory = category;
        };
        if (Array.isArray(draft.selections)) {
          draft.selections.forEach((item) => restore(categories.find((category) => category.dataset.categoryId === item.categoryId), String(item.variantId), item.qty));
        } else {
          draft.items.forEach((item) => {
            const allocations = item.allocations ? JSON.parse(item.allocations) : null;
            if (Array.isArray(allocations)) {
              allocations.forEach((allocation) => restore(categories.find((category) => category.dataset.categoryId === allocation.categoryId), item.variantId, allocation.qty));
            } else {
              // Compatibility with kits added before category allocation metadata existed.
              let remaining = item.quantity;
              categories.filter((category) => isCategoryEnabled(category) &&
                state.selections[category.dataset.categoryId]?.[item.variantId] &&
                item.categories.split(', ').includes(category.dataset.categoryTitle || 'Categoria')
              ).forEach((category) => {
                const qty = Math.min(remaining, Math.max(0, getLimit(category) - categoryTotal(category.dataset.categoryId)));
                if (qty > 0) { restore(category, item.variantId, qty); remaining -= qty; }
              });
              if (remaining) skipped = true;
            }
          });
        }
        editingDraft = draft;
        selectedKitId = draft.kitId;
        if (skipped) window.alert('Alguns produtos ou limites mudaram. Confira sua sele\u00e7\u00e3o antes de adicionar o kit novamente.');
      } catch (error) {
        window.alert(error.message || 'N\u00e3o foi poss\u00edvel recuperar a sele\u00e7\u00e3o do kit.');
      }
    };

    const render = () => {
      const plan =
        activePlan();

      if (!plan) return;

      updateCategoryVisibility();
      saveEditingSelection();

      plans.forEach(
        (item) => {
          const active =
            item === plan;

          item.classList.toggle(
            'is-active',
            active
          );

          item.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );
        }
      );

      categories.forEach(
        (category) => {
          if (
            !isCategoryEnabled(
              category
            )
          ) {
            return;
          }

          const categoryId =
            category.dataset.categoryId;

          const total =
            categoryTotal(
              categoryId
            );

          const limit =
            getLimit(category);

          const complete =
            total >= limit;

          const counter =
            category.querySelector(
              '[data-bendu-counter]'
            );

          if (counter) {
            counter.textContent =
              `${total}/${limit}`;
          }

          const stepSubtitle =
            category.querySelector(
              '.bendu-kit-builder__step-subtitle'
            );

          if (
            stepSubtitle &&
            !stepSubtitle.hasAttribute(
              'data-bendu-subtitle-custom'
            )
          ) {
            const categoryTitle =
              category.dataset.categoryTitle ||
              '';

            stepSubtitle.textContent =
              `Escolha ${limit} ${
                limit === 1 ? 'unidade' : 'unidades'
              } de ${categoryTitle}`;
          }

          const mobileCategoryChip =
            section.querySelector(
              `[data-bendu-mobile-category="${categoryId}"]`
            );

          if (mobileCategoryChip) {
            mobileCategoryChip.textContent =
              `${total}/${limit}`;

            mobileCategoryChip.classList.toggle(
              'is-complete',
              complete
            );
          }

          category.classList.toggle(
            'is-complete',
            complete
          );

          const summaryRow =
            section.querySelector(
              `[data-summary-category="${categoryId}"]`
            );

          const summaryValue =
            summaryRow?.querySelector(
              '[data-summary-category-value]'
            );

          if (summaryValue) {
            const text =
              buildCategorySummary(
                category
              );

            summaryValue.textContent =
              text
                ? text
                : `Selecione ${limit}`;
          }

          if (summaryRow) {
            summaryRow.classList.toggle(
              'is-complete',
              complete
            );
          }

          updateProductCards(
            category
          );
        }
      );

      const price =
        Number(plan.dataset.price || 0);

      const cashbackRate =
        Number(plan.dataset.cashback || 0);

      const cashbackValue =
        Math.round(
          price *
            cashbackRate /
            100
        );

      const units =
        Number(
          plan.dataset.units || 0
        );

      if (summaryKit) {
        summaryKit.textContent =
          `Kit ${state.kit} · ${units} unidades`;
      }

      if (summaryTotal) {
        summaryTotal.textContent =
          formatMoney(price);
      }

      if (summaryCashback) {
        summaryCashback.textContent =
          formatMoney(
            cashbackValue
          );
      }

      if (
        summaryCashbackRate
      ) {
        summaryCashbackRate.textContent =
          `${cashbackRate}%`;
      }

      const hasFreeShipping =
        String(
          plan.dataset.freeShipping || 'false'
        ) === 'true';

      if (summaryFreeShipping) {
        summaryFreeShipping.hidden =
          !hasFreeShipping;

        summaryFreeShipping.style.display =
          hasFreeShipping
            ? 'flex'
            : 'none';
      }

      if (mobileFreeShipping) {
        mobileFreeShipping.hidden =
          !hasFreeShipping;

        mobileFreeShipping.style.display =
          hasFreeShipping
            ? 'flex'
            : 'none';
      }

      if (mobileKit) {
        mobileKit.textContent =
          `KIT ${state.kit}`;
      }

      if (mobileTotal) {
        mobileTotal.textContent =
          formatMoney(price);
      }

      if (mobileUnits) {
        mobileUnits.textContent =
          units;
      }

      if (mobileCashback) {
        mobileCashback.textContent =
          formatMoney(cashbackValue);
      }

      if (mobileCashbackRate) {
        mobileCashbackRate.textContent =
          `${cashbackRate}%`;
      }

      buildSlots();

      const incomplete =
        categories.filter(
          (category) =>
            isCategoryEnabled(
              category
            ) &&
            !isCategoryComplete(
              category
            )
        );

      const complete =
        incomplete.length === 0;

      cta.disabled =
        !complete;

      if (mobileCta) {
        mobileCta.disabled =
          !complete;
      }

      if (mobileCtaText && ctaText) {
        mobileCtaText.textContent =
          ctaText.textContent;
      }

      const kitUnits =
        Number(
          plan?.dataset.units || 0
        );

      const selectedUnits =
        getSelectedUnits();

      const remainingItems =
        Math.max(
          kitUnits - selectedUnits,
          0
        );

      if (mobileStatus) {
        mobileStatus.textContent = complete
          ? 'KIT PRONTO PARA ADICIONAR'
          : `FALTAM ${remainingItems} ${remainingItems === 1 ? 'ITEM' : 'ITENS'} PARA LIBERAR`;
      }

      if (mobileBar) {
        mobileBar.classList.toggle(
          'is-ready',
          complete
        );
      }

      if (summary) {
        summary.classList.toggle(
          'is-ready',
          complete
        );
      }

      if (missing) {
        if (complete) {
          missing.textContent =
            '';
        } else {
          missing.textContent =
            `Falta escolher: ${incomplete
              .map(
                (category) =>
                  category.dataset
                    .categoryTitle
              )
              .join(', ')}`;
        }
      }
    };

    const addOne = (
      category,
      card
    ) => {
      if (
        !isCategoryEnabled(
          category
        )
      ) {
        return;
      }

      const categoryId =
        category.dataset.categoryId;

      const limit =
        getLimit(category);

      const currentTotal =
        categoryTotal(
          categoryId
        );

      if (
        currentTotal >= limit
      ) {
        return;
      }

      const variantId =
        String(
          card.dataset.variantId ||
          ''
        );

      const item =
        state.selections[
          categoryId
        ][variantId];

      if (!item) return;

      item.qty += 1;

      render();

      if (
        isCategoryComplete(
          category
        )
      ) {
        window.setTimeout(
          () => {
            openNextIncomplete(
              category
            );
          },
          180
        );
      }
    };

    const removeOne = (
      category,
      card
    ) => {
      if (
        !isCategoryEnabled(
          category
        )
      ) {
        return;
      }

      const categoryId =
        category.dataset.categoryId;

      const variantId =
        String(
          card.dataset.variantId ||
          ''
        );

      const item =
        state.selections[
          categoryId
        ][variantId];

      if (
        !item ||
        item.qty <= 0
      ) {
        return;
      }

      item.qty -= 1;

      render();

      openCategory(
        category,
        {
          scroll: false
        }
      );
    };

    plans.forEach((plan) => {
      plan.addEventListener(
        'click',
        () => {
          const nextKit =
            String(
              plan.dataset.benduPlan
            );

          if (
            state.kit === nextKit
          ) {
            return;
          }

          state.kit =
            nextKit;

          selectedKitId = null;
          resetSelections();

          render();

          closeAllCategories();

          const next =
            firstIncompleteCategory();

          if (next) {
            openCategory(
              next,
              {
                scroll: false
              }
            );
          }
        }
      );
    });

    if (mobileKit) {
      const scrollToActiveKit = () => {
        const currentPlan =
          activePlan();

        if (!currentPlan) return;

        currentPlan.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      };

      mobileKit.addEventListener(
        'click',
        scrollToActiveKit
      );

      mobileKit.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key === 'Enter' ||
            event.key === ' '
          ) {
            event.preventDefault();
            scrollToActiveKit();
          }
        }
      );
    }

    categories.forEach(
      (category) => {
        const head =
          category.querySelector(
            '.bendu-kit-builder__step-head'
          );

        if (head) {
          head.setAttribute(
            'role',
            'button'
          );

          head.setAttribute(
            'tabindex',
            '0'
          );

          const toggleCategory =
            () => {
              if (
                !isCategoryEnabled(
                  category
                )
              ) {
                return;
              }

              const isOpen =
                category.classList.contains(
                  'is-open'
                );

              if (isOpen) {
                category.classList.remove(
                  'is-open'
                );

                category.classList.add(
                  'is-collapsed'
                );

                state.openCategoryId =
                  null;
              } else {
                openCategory(
                  category,
                  {
                    scroll: false
                  }
                );
              }
            };

          head.addEventListener(
            'click',
            (event) => {
              if (
                event.target.closest(
                  'button'
                )
              ) {
                return;
              }

              toggleCategory();
            }
          );

          head.addEventListener(
            'keydown',
            (event) => {
              if (
                event.key ===
                  'Enter' ||
                event.key === ' '
              ) {
                event.preventDefault();

                toggleCategory();
              }
            }
          );
        }

        category
          .querySelectorAll(
            '[data-bendu-product]'
          )
          .forEach((card) => {
            const hit =
              card.querySelector(
                '[data-bendu-add-one]'
              );

            const plus =
              card.querySelector(
                '[data-bendu-plus]'
              );

            const minus =
              card.querySelector(
                '[data-bendu-minus]'
              );

            if (hit) {
              hit.addEventListener(
                'click',
                (event) => {
                  event.preventDefault();

                  addOne(
                    category,
                    card
                  );
                }
              );
            }

            if (plus) {
              plus.addEventListener(
                'click',
                (event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  addOne(
                    category,
                    card
                  );
                }
              );
            }

            if (minus) {
              minus.addEventListener(
                'click',
                (event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  removeOne(
                    category,
                    card
                  );
                }
              );
            }
          });
      }
    );

    if (mobileCta) {
      mobileCta.addEventListener(
        'click',
        () => {
          if (!mobileCta.disabled) {
            cta.click();
          }
        }
      );
    }

    cta.addEventListener(
      'click',
      async () => {
        if (cta.disabled) return;

        const plan =
          activePlan();

        if (!plan) return;

        const originalText =
          ctaText?.textContent ||
          'ADICIONAR AO CARRINHO';

        // One identity per assembly, shared by all lines in this request.
        const kitId = `bendu-kit-${window.crypto.randomUUID()}`;

        const cartItemsMap =
          new Map();

        categories.forEach(
          (category) => {
            if (
              !isCategoryEnabled(
                category
              )
            ) {
              return;
            }

            const categoryId =
              category.dataset.categoryId;

            const categoryTitle =
              category.dataset.categoryTitle ||
              'Categoria';

            Object.values(
              state.selections[
                categoryId
              ] || {}
            ).forEach((item) => {
              if (
                Number(item.qty || 0) <= 0
              ) {
                return;
              }

              const variantId =
                Number(item.variantId);

              if (!variantId) {
                return;
              }

              if (
                cartItemsMap.has(
                  variantId
                )
              ) {
                const current =
                  cartItemsMap.get(
                    variantId
                  );

                current.quantity +=
                  Number(item.qty || 0);

                current.properties[
                  '_Categorias do Kit'
                ] =
                  `${current.properties['_Categorias do Kit']}, ${categoryTitle}`;
              } else {
                cartItemsMap.set(
                  variantId,
                  {
                    id: variantId,

                    quantity:
                      Number(
                        item.qty || 0
                      ),

                    properties: {
                      'Kit Bendu':
                        `Kit ${state.kit}`,

                      '_Categorias do Kit':
                        categoryTitle,
                      '_bendu_kit': 'true',
                      '_bendu_kit_id': kitId,
                      '_bendu_kit_number': String(state.kit),
                      '_bendu_kit_units': String(plan.dataset.units || '')
                    }
                  }
                );
              }
            });
          }
        );

        // Keep exact category quantities even when one variant belongs to multiple categories.
        cartItemsMap.forEach((line) => {
          const allocations = categories.flatMap((category) => {
            const categoryId = category.dataset.categoryId;
            const qty = state.selections[categoryId]?.[String(line.id)]?.qty || 0;
            return isCategoryEnabled(category) && qty > 0 ? [{ categoryId, qty }] : [];
          });
          line.properties._bendu_kit_allocations = JSON.stringify(allocations);
        });

        const cartItems =
          Array.from(
            cartItemsMap.values()
          );

        if (!cartItems.length) {
          return;
        }

        cta.disabled = true;

        if (ctaText) {
          ctaText.textContent =
            'ADICIONANDO...';
        }

        if (mobileCtaText) {
          mobileCtaText.textContent =
            'ADICIONANDO...';
        }

        try {
          const root =
            window.Shopify?.routes
              ?.root || '/';

          const cartDrawer =
            document.querySelector(
              'cart-drawer, #CartDrawer, [data-cart-drawer]'
            );

          let sectionsToRender = [];

          if (
            cartDrawer &&
            typeof cartDrawer.getSectionsToRender ===
              'function'
          ) {
            try {
              sectionsToRender =
                cartDrawer
                  .getSectionsToRender()
                  .map((sectionData) =>
                    sectionData?.section ||
                    sectionData?.id
                  )
                  .filter(Boolean);
            } catch (error) {
              console.warn(
                '[Bendu Kit] Não foi possível obter sections do cart drawer.',
                error
              );
            }
          }

          const addPayload = {
            items:
              cartItems
          };

          if (
            sectionsToRender.length
          ) {
            addPayload.sections =
              sectionsToRender;

            addPayload.sections_url =
              window.location.pathname;
          }

          const response =
            await fetch(
              `${root}cart/add.js`,
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json'
                },

                body:
                  JSON.stringify(
                    addPayload
                  )
              }
            );

          if (!response.ok) {
            const error =
              await response
                .json()
                .catch(
                  () => ({})
                );

            throw new Error(
              error.description ||
                'Não foi possível adicionar o kit.'
            );
          }

          const addResult =
            await response.json();

          selectedKitId = kitId;

          if (editingDraft) {
            try { sessionStorage.removeItem(editingStorageKey); } catch (_) {}
            editingDraft = null;
            const url = new URL(window.location.href);
            url.searchParams.delete('bendu_edit');
            window.history.replaceState({}, '', url);
          }

          let freshCart = null;

          try {
            const cartResponse =
              await fetch(
                `${root}cart.js`,
                {
                  headers: {
                    Accept:
                      'application/json'
                  },
                  cache:
                    'no-store'
                }
              );

            if (
              cartResponse.ok
            ) {
              freshCart =
                await cartResponse.json();
            }
          } catch (error) {
            console.warn(
              '[Bendu Kit] Não foi possível buscar cart.js.',
              error
            );
          }

          let drawerRendered =
            false;

          if (
            cartDrawer &&
            typeof cartDrawer.renderContents ===
              'function' &&
            addResult?.sections
          ) {
            try {
              cartDrawer.renderContents(
                addResult
              );

              drawerRendered =
                true;
            } catch (error) {
              console.warn(
                '[Bendu Kit] renderContents do drawer falhou.',
                error
              );
            }
          }

          const eventDetail = {
            cart:
              freshCart ||
              addResult,

            open:
              true,

            source:
              'bendu-kit'
          };

          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true,
                detail:
                  eventDetail
              }
            )
          );

          document.dispatchEvent(
            new CustomEvent(
              'cart:change',
              {
                bubbles: true,
                detail:
                  eventDetail
              }
            )
          );

          document.documentElement.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true,
                detail:
                  eventDetail
              }
            )
          );

          window.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                detail:
                  eventDetail
              }
            )
          );

          window.dispatchEvent(
            new CustomEvent(
              'cart:change',
              {
                detail:
                  eventDetail
              }
            )
          );

          if (freshCart) {
            const itemCount =
              Number(
                freshCart.item_count ||
                0
              );

            const countSelectors = [
              '[data-cart-count]',
              '.cart-count-bubble span[aria-hidden="true"]',
              '.cart-count-bubble',
              '[data-header-cart-count]',
              '.header__cart-count'
            ];

            countSelectors.forEach(
              (selector) => {
                document
                  .querySelectorAll(
                    selector
                  )
                  .forEach(
                    (element) => {
                      if (
                        element.children
                          .length === 0 ||
                        element.matches(
                          '[data-cart-count], [data-header-cart-count], .header__cart-count'
                        )
                      ) {
                        element.textContent =
                          itemCount;
                      }

                      element.hidden =
                        itemCount <= 0;
                    }
                  );
              }
            );
          }

          if (cartDrawer) {
            window.setTimeout(
              () => {
                try {
                  if (
                    typeof cartDrawer.open ===
                      'function'
                  ) {
                    cartDrawer.open();
                    return;
                  }

                  if (
                    typeof cartDrawer.show ===
                      'function'
                  ) {
                    cartDrawer.show();
                    return;
                  }

                  const cartTrigger =
                    document.querySelector(
                      '[aria-controls="cart-drawer"], [aria-controls="CartDrawer"], [data-action="open-cart"], [data-cart-toggle]'
                    );

                  if (
                    cartTrigger &&
                    typeof cartTrigger.click ===
                      'function'
                  ) {
                    cartTrigger.click();
                  }
                } catch (error) {
                  console.warn(
                    '[Bendu Kit] Não foi possível abrir o cart drawer.',
                    error
                  );
                }
              },
              drawerRendered
                ? 50
                : 180
            );
          }

          if (ctaText) {
            ctaText.textContent =
              'ADICIONADO ✓';
          }

          if (mobileCtaText) {
            mobileCtaText.textContent =
              'ADICIONADO ✓';
          }

          window.setTimeout(
            () => {
              if (ctaText) {
                ctaText.textContent =
                  originalText;
              }

              if (mobileCtaText) {
                mobileCtaText.textContent =
                  originalText;
              }

              render();
            },
            1400
          );
        } catch (error) {
          console.error(
            '[Bendu Kit]',
            error
          );

          if (ctaText) {
            ctaText.textContent =
              'TENTE NOVAMENTE';
          }

          if (mobileCtaText) {
            mobileCtaText.textContent =
              'TENTE NOVAMENTE';
          }

          if (missing) {
            missing.textContent =
              error.message ||
              'Erro ao adicionar o kit ao carrinho.';
          }

          window.setTimeout(
            () => {
              if (ctaText) {
                ctaText.textContent =
                  originalText;
              }

              if (mobileCtaText) {
                mobileCtaText.textContent =
                  originalText;
              }

              render();
            },
            2000
          );
        }
      }
    );

    const benefits = section.querySelector(
      '.bendu-kit-builder__benefits'
    );

    if (benefits) {
      const benefitItems = Array.from(
        benefits.querySelectorAll(
          '.bendu-kit-builder__benefit'
        )
      );

      let benefitIndex = 0;
      let benefitTimer = null;

      const rotateBenefits = () => {
        if (
          !window.matchMedia('(max-width: 749px)').matches ||
          benefitItems.length <= 1
        ) {
          return;
        }

        benefitIndex =
          (benefitIndex + 1) % benefitItems.length;

        const target = benefitItems[benefitIndex];

        benefits.scrollTo({
          left: target.offsetLeft - benefits.offsetLeft,
          behavior: 'smooth'
        });
      };

      const startBenefitsAutoplay = () => {
        if (benefitTimer) {
          window.clearInterval(benefitTimer);
        }

        if (
          window.matchMedia('(max-width: 749px)').matches &&
          benefitItems.length > 1
        ) {
          benefitTimer = window.setInterval(
            rotateBenefits,
            4000
          );
        }
      };

      benefits.addEventListener(
        'scroll',
        () => {
          if (!window.matchMedia('(max-width: 749px)').matches) {
            return;
          }

          let closestIndex = 0;
          let closestDistance = Infinity;

          benefitItems.forEach((item, index) => {
            const distance = Math.abs(
              item.offsetLeft -
              benefits.offsetLeft -
              benefits.scrollLeft
            );

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          benefitIndex = closestIndex;
        },
        { passive: true }
      );

      window.addEventListener(
        'resize',
        startBenefitsAutoplay,
        { passive: true }
      );

      startBenefitsAutoplay();
    }

    const updateMobileBarVisibility = () => {
      if (!mobileBar) return;

      if (
        window.matchMedia(
          '(min-width: 750px)'
        ).matches
      ) {
        mobileBar.classList.remove(
          'is-visible'
        );
        return;
      }

      const plansStep = section.querySelector(
        '.bendu-kit-builder__step--plans'
      );

      const sectionRect =
        section.getBoundingClientRect();

      const activationPoint =
        window.innerHeight * 0.55;

      const plansRect =
        plansStep?.getBoundingClientRect();

      const shouldShow =
        !!plansRect &&
        plansRect.bottom <= activationPoint &&
        sectionRect.bottom > 0;

      mobileBar.classList.toggle(
        'is-visible',
        shouldShow
      );
    };

    let mobileBarFrame = null;

    const scheduleMobileBarVisibility =
      () => {
        if (mobileBarFrame) return;

        mobileBarFrame =
          window.requestAnimationFrame(
            () => {
              mobileBarFrame = null;
              updateMobileBarVisibility();
            }
          );
      };

    window.addEventListener(
      'scroll',
      scheduleMobileBarVisibility,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      scheduleMobileBarVisibility,
      {
        passive: true
      }
    );

    const clearRemovedKit = (kitId) => {
      if (!section.isConnected || !kitId || selectedKitId !== kitId) return;
      selectedKitId = null;
      editingDraft = null;
      editingStorageKey = null;
      editingFocusCategory = null;
      const url = new URL(window.location.href);
      if (url.searchParams.get('bendu_edit') === kitId) {
        url.searchParams.delete('bendu_edit');
        window.history.replaceState({}, '', url);
      }
      resetSelections();
      render();
      closeAllCategories();
      const next = firstIncompleteCategory();
      if (next) openCategory(next, { scroll: false });
    };
    document.addEventListener('bendu-kit:removed', (event) => clearRemovedKit(event.detail?.kitId));
    // Mobile browsers can restore this page, including its JS state, from back/forward cache.
    window.addEventListener('pageshow', () => {
      try {
        if (selectedKitId && sessionStorage.getItem('bendu-kit-removed:' + selectedKitId) === 'true') {
          clearRemovedKit(selectedKitId);
        }
      } catch (_) {}
    });

    restoreEditingSelection();
    render();

    updateMobileBarVisibility();

    closeAllCategories();

    const initialCategory =
      editingFocusCategory || firstIncompleteCategory();

    if (initialCategory) {
      openCategory(
        initialCategory,
        {
          scroll: false
        }
      );
    }
    if (editingFocusCategory && editingDraft) {
      const card = Array.from(editingFocusCategory.querySelectorAll('[data-bendu-product]'))
        .find((item) => String(item.dataset.variantId) === editingDraft.focusVariant);
      if (card) window.requestAnimationFrame(() => {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        card.setAttribute('tabindex', '-1');
        card.focus({ preventScroll: true });
      });
    }
  };

  const boot = () => {
    document
      .querySelectorAll(
        '[data-bendu-kit-builder]'
      )
      .forEach(init);
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (
        event.target.matches?.(
          '[data-bendu-kit-builder]'
        )
      ) {
        init(
          event.target
        );
      }

      event.target
        .querySelectorAll?.(
          '[data-bendu-kit-builder]'
        )
        .forEach(init);
    }
  );
})();
